import {IApiBusinessProfileProto, space} from "./compiled";
import {useMemo} from "react";
import IServiceProto = space.kenko.proto.IServiceProto;

type Props = {
  business: IApiBusinessProfileProto | undefined,
  practitionerFilter: string | null | undefined,
  onSelect: (service: IServiceProto) => void;
}

export const ChooseService = (props: Props) => {


  const practitionerOffersService = (service: IServiceProto, providerId: string) => {

    // Make sure this services is offered by the practitioner (if set) 
    if (!service.offeredBy || !service.offeredBy.length) {
      return;
    }

    for (let i = 0; i < service.offeredBy.length; i++) {

      const offering = service.offeredBy[i];
      if (offering.providerId == providerId) {
        return true;
      }
    }

    return false;
  }

  const getServicesByCategory = useMemo(() => {

    const services = new Map<string, IServiceProto[]>();

    props.business?.practice?.services?.forEach(service => {

      if (props.practitionerFilter && !practitionerOffersService(service, props.practitionerFilter)) {
        // Service not offered by this practitioner.
        return;
      }

      const category = service.category || '';

      // Create a new array or append to existing (multimap behavior)
      if (!services.has(category)) {
        services.set(category, [service]);
      } else {
        // @ts-ignore
        services.get(category).push(service);
      }
    });

    return services;

  }, [props.business, props.practitionerFilter])

  return <div style={{display: 'flex', flexDirection: "column", textAlign: 'start'}}>
    <h3>Select Service Type</h3>

    {Array.from(getServicesByCategory).map(([category, services]) => {
      return <>
        <h4>{category}</h4>
        {services.map(service => {
          return <button key={'serv' + service.sku} className={'BookingOverlaySelectable'} onClick={() => {
            props.onSelect(service)
          }}>
            <div><b>{service.name} ({service.lengthMinutes} min)</b></div>
            <div>{service.description}</div>
          </button>
        })}
      </>
    })}
  </div>
}